const collection = {
  slug: "comme-des-garcons-1982aw-holes-destroy-guide",
  metaTitle:
    "コムデギャルソン名作黒の衝撃とは｜1982AW Holes / Destroyと買取ガイド",
  metaDescription:
    "COMME des GARÇONS 名作 1982AW『Holes』/『Destroy』を解説。黒、穴、ほつれ、破れ、だぼだぼのシルエットによって西洋的な女性美や身体の曲線を拒否した、いわゆる黒の衝撃。コムデギャルソン名作、アーカイブ価値、買取相談までEnclopediaが詳しく案内します。",
  metaKeywords:
    "コムデギャルソン 黒の衝撃,コムデギャルソン 名作,コムデギャルソン Holes,COMME des GARCONS 1982AW,COMME des GARCONS Holes,COMME des GARCONS Destroy,コムデギャルソン Destroy,コムデギャルソン ボロルック,川久保玲 黒の衝撃,川久保玲 名作,コムデギャルソン アーカイブ,COMME des GARCONS アーカイブ,コムデギャルソン 買取,COMME des GARCONS 買取,コムデギャルソン 高価買取,コムデギャルソン 古着 買取,コムデギャルソン レディース 買取,Enclopedia,アンクロペディア",
  canonicalPath:
    "/archive_collection/comme-des-garcons-1982aw-holes-destroy-guide",
  heroImage: "media/archive_fashion/archive8.png",
  heroImageAlt:
    "COMME des GARÇONS 1982AW Holes Destroy 黒の衝撃を解説するEnclopediaアーカイブガイド画像",
  heroNumber: "09 / BLACK SHOCK",
  label: "ARCHIVE COLLECTION STUDY",
  title: "COMME des GARÇONS 1982AW『Holes』/『Destroy』",
  lead: "COMME des GARÇONS 1982AW『Holes』/『Destroy』。\nいわゆる「黒の衝撃」として語られる、川久保玲の最重要級コレクションです。\n\n黒を中心にした服。\n穴のあいたニットや布。\nほつれ、破れ、未完成に見える質感。\n身体に沿わない、だぼっとしたシルエット。\n\nそれは、西洋的な“女性らしい美しさ”や“身体の曲線”を拒否する造形でした。\nこのコレクションを理解すると、なぜCOMME des GARÇONSが単なる黒い服のブランドではなく、ファッションの価値観そのものを変えた存在として語られるのかが見えてきます。",
  keywordLine: ["holes", "destroy", "black shock", "buyback guide"],
  thesis:
    "1982AW『Holes』/『Destroy』の重要性は、黒い服を発表したことではなく、西洋ファッションが前提としていた華やかさ、女性らしさ、身体美を真正面から崩した点にあります。",
  whyTitle: "なぜ1982AWは「黒の衝撃」と呼ばれたのか。",
  whyBody:
    "1980年代初頭の西洋ファッションでは、色彩、装飾、女性のボディライン、華やかなセクシュアリティを強調する服が主流でした。\nそこに川久保玲は、黒く、穴があき、ほつれ、破れ、身体に沿わない服を提示します。\n\n当時の視点から見れば、それは美しく整った服ではなく、未完成で、壊れていて、貧しく見えるものだったかもしれません。\nだから欧米メディアでは批判的に“ボロルック”のように受け取られました。\n\nしかし後から見ると、このコレクションは完全に、脱構築ファッション、アンチ・ファッション、黒のモード、ジェンダーレスな身体観の起点の一つです。\n\n重要なのは、黒そのものではありません。\n身体を美しく見せるための服ではなく、身体を隠し、歪ませ、服そのものの存在を前に出す服を作ったこと。\nそこに、COMME des GARÇONSの歴史的な強度があります。\nEnclopediaでは、このような文脈を入口に、コムデギャルソンのアーカイブ価値を読み取り、買取やレンタルを通じて次のユーザーへつなげます。",
  pillars: [
    {
      number: "01",
      title: "BLACK AS IMPACT",
      text: "1982AWの黒は、単なる色ではありません。華やかな色彩や装飾が主流だった時代に、黒そのものが価値観への反抗として機能しました。",
    },
    {
      number: "02",
      title: "HOLES AS STRUCTURE",
      text: "穴、破れ、ほつれは、劣化や欠点ではなく、服の構造そのものになりました。壊れたように見える布が、新しい美しさを作ります。",
    },
    {
      number: "03",
      title: "BODY AS REFUSAL",
      text: "身体の曲線を美しく見せるのではなく、身体の輪郭を曖昧にし、だぼっとした量感で覆う。そこに西洋的な女性美への拒否があります。",
    },
  ],
  readingTitle: "黒、穴、ほつれ、だぼだぼの身体から読む『Holes』/『Destroy』。",
  readingIntro:
    "このコレクションは、黒いから有名なのではありません。どのように穴が開けられ、なぜ破れやほつれが美しさになり、なぜ身体に沿わないシルエットが衝撃を与えたのかを見ることで、COMME des GARÇONSの原点が見えてきます。",
  observations: [
    {
      index: "01",
      title: "黒は、華やかさへの拒否だった",
      text: "1982AWで提示された黒は、単なるカラーパレットではありません。\n当時の西洋ファッションが求めていた華やかさ、色彩、装飾性に対する強烈な距離でした。\n\n黒は身体を目立たせるためではなく、身体を沈め、輪郭を曖昧にし、服の構造そのものを前に出すために使われます。\nだからこそ、この黒は“無難な黒”ではなく、見る人の価値観を揺さぶる黒でした。",
    },
    {
      index: "02",
      title: "穴は、欠損ではなく新しい装飾だった",
      text: "『Holes』という呼称が示すように、このコレクションでは穴のあいたニットや布が重要な要素になります。\n一般的に穴は、傷、劣化、貧しさ、未完成を連想させます。\n\nしかし川久保玲は、その穴を服の弱点としてではなく、服を成立させる要素として提示しました。\n穴があるからこそ、布の重さが変わり、肌との距離が変わり、視線の抜けが生まれる。\n壊れているように見えるものが、新しい造形になる。\nここに“Destroy”の本質があります。",
    },
    {
      index: "03",
      title: "ほつれ、破れ、未完成に見える質感が価値になった",
      text: "COMME des GARÇONS 1982AWでは、完璧に仕立てられた服とは逆の表情が現れます。\nほつれ、破れ、引き裂かれたような質感、洗いざらしのような表面。\n\nそれは単に荒い服ではありません。\n完成された美しさだけを価値とするファッションに対して、未完成に見えるもの、壊れて見えるもの、粗く見えるものの中にも美しさがあると提示したのです。\n後の脱構築ファッションを考えるうえでも、この視点は非常に重要です。",
    },
    {
      index: "04",
      title: "だぼだぼのシルエットは、身体美を拒否した",
      text: "当時の西洋ファッションでは、女性の身体の曲線を強調することが美しさの重要な条件でした。\nしかし1982AWのCOMME des GARÇONSは、身体に沿わない、だぼっとしたシルエットを提示します。\n\n身体をきれいに見せるのではなく、隠す。\nウエストや胸のラインを強調するのではなく、布の量感で覆う。\nその結果、服は身体の補助ではなく、身体の見え方そのものを変える存在になります。\nこの姿勢は、後のジェンダーレスな身体観やアンチ・ファッションにもつながります。",
    },
    {
      index: "05",
      title: "“ボロルック”という批判は、価値観の衝突だった",
      text: "欧米メディアがこのコレクションを批判的に受け取った背景には、服に対する価値観の違いがあります。\n美しい服とは、整っていて、華やかで、身体を魅力的に見せるもの。\nその前提から見れば、黒く、穴があり、破れていて、身体を隠す服は“ボロ”に見えたかもしれません。\n\nしかし、その批判こそが、このコレクションの強さを示しています。\n既存の美しさの基準に収まらなかったからこそ、後から見たときに歴史的な転換点として残りました。",
    },
    {
      index: "06",
      title: "Holes / Destroy / 黒の衝撃 / ボロルックの違い",
      text: "このコレクションは、複数の呼び方で語られます。\n\nHolesは、穴のあいた服やニットを中心に見た呼び方。\nDestroyは、破壊、脱構築、引き裂き、ほつれのニュアンスが強い呼び方。\n黒の衝撃は、日本語圏で語られる歴史的な呼び方。\nボロルックは、当時の欧米メディア側の批判的なラベリングです。\n\n呼び方は違っても、中心にあるのは同じです。\n服が身体を美しく飾るものだという前提を、黒、穴、破れ、量感によって根本から揺さぶったことです。",
    },
    {
      index: "07",
      title: "買取で見るべきなのは、古さではなく歴史的な文脈",
      text: "コムデギャルソンの買取では、単に古い服だから価値がある、という見方では不十分です。\nどのシーズンか。どのラインか。どんなテーマと接続しているか。どれだけブランド史の中で重要か。\n\n1982AWのような象徴的コレクションは、まさに文脈が価値になる代表例です。\nEnclopediaでは、コムデギャルソンの服を単なる古着としてではなく、ブランドの思想やコレクション背景まで含めて確認します。",
    },
  ],
  quote:
    "1982AW『Holes』/『Destroy』は、黒い服のコレクションではない。西洋ファッションが信じていた“美しい身体”への反論です。",
  perspectiveTitle:
    "Enclopediaは、コムデギャルソンを“古着”ではなく“価値観を変えたアーカイブ”として見る。",
  perspectiveCards: [
    {
      number: "01",
      title: "KNOWLEDGE",
      text: "1982AW『Holes』/『Destroy』を、黒、穴、ほつれ、身体美の否定、川久保玲の思想から読み解きます。",
    },
    {
      number: "02",
      title: "SERVICE ENTRY",
      text: "この記事は、コムデギャルソンの名作を知る入口であると同時に、Enclopediaが服をどのように読み、扱い、次へつなげるサービスなのかを知ってもらう入口です。",
    },
    {
      number: "03",
      title: "BUYBACK",
      text: "買取対象は1982AWだけに限定しません。COMME des GARÇONS、HOMME PLUS、JUNYA WATANABE、noir kei ninomiyaなど、コムデギャルソン全般を文脈込みで相談対象として見ます。",
    },
  ],
  experienceTitle:
    "コムデギャルソンを売る前に、その一着がどの文脈にあるかを確認する。",
  experienceBody:
    "コムデギャルソンの買取では、ブランド名だけでなく、ライン、年代、シーズン、デザイナー、素材、状態、現在の需要が重要です。\n今回の記事では1982AW『Holes』/『Destroy』を中心に解説していますが、Enclopediaが見ているのはこのシーズンだけではありません。\nCOMME des GARÇONS、COMME des GARÇONS HOMME PLUS、COMME des GARÇONS HOMME、JUNYA WATANABE、noir kei ninomiya、tao COMME des GARÇONSなど、コムデギャルソン全般を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n黒の衝撃を知ることは、自分の持っている一着の価値を見直す入口になります。",
  experienceItems: [
    "COMME des GARÇONSのライン名を確認する",
    "タグ・品質表示・年代・シーズンが分かる写真を撮影する",
    "黒、穴、ほつれ、破れなどのディテールを確認する",
    "HOMME PLUS、JUNYA、noirなどラインごとの特徴を確認する",
    "1982AWなど名作シーズンに近い文脈があるか確認する",
    "シーズンや価値が分からない場合もLINEで写真を送る",
  ],
  archiveItemsTitle: "コムデギャルソンの名作を入口に、買取相談へつなげる。",
  archiveItemsBody:
    "Enclopediaでは、コムデギャルソンを単なるブランド古着としてではなく、コレクション背景、ライン、年代、思想、現在の需要まで含めて見ています。この記事で1982AWの重要性に触れた方は、所有しているコムデギャルソンの一着も、まずはLINEでご相談ください。",
  archiveItems: [
    {
      label: "BUYBACK FOCUS 01",
      title: "コムデギャルソン買取ページへ",
      productPath: "/brand_buyback/comme-des-garcons",
      productImage: "",
      text: "COMME des GARÇONS、HOMME PLUS、HOMME、JUNYA WATANABE、noir kei ninomiyaまで。コムデギャルソン全般の買取対象と査定視点を確認できます。",
    },
    {
      label: "BUYBACK FOCUS 02",
      title: "LINEでコムデギャルソンを事前査定",
      productPath: "https://line.me/R/ti/p/@240yzqkh",
      productImage: "",
      text: "タグ、品質表示、全体写真、ディテール写真を送るだけで、宅配買取へ進む前におおまかな査定方向を確認できます。シーズンが分からない場合も相談可能です。",
    },
    {
      label: "SERVICE FOCUS 03",
      title: "Enclopediaのアーカイブレンタルを見る",
      productPath: "/",
      productImage: "",
      text: "Enclopediaは買取だけでなく、アーカイブを次の人が体験できるレンタルサービスです。服を所有物ではなく、文化として循環させます。",
    },
  ],
  finalCta: {
    title:
      "黒の衝撃の記事を読んだら、次はEnclopediaでコムデギャルソンの価値を相談する。",
    body: "COMME des GARÇONS 1982AW『Holes』/『Destroy』は、コムデギャルソンの名作を知るための強い入口です。\nただし、Enclopediaが見ているのはこのシーズンだけではありません。\nCOMME des GARÇONS、HOMME PLUS、JUNYA WATANABE、noir kei ninomiyaまで、コムデギャルソン全般の価値をアーカイブの視点で確認します。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
    buttonLabel: "コムデギャルソンをLINEで事前査定する",
    buttonHref: "https://line.me/R/ti/p/@240yzqkh",
  },
};

export default collection;
